import type { ExperimentsMonitorManager } from '@/state/experiments/useExperimentsMonitor';
import { MetricGrid, MetricTile, Meter } from '../ConsolePanel';

/**
 * Three tiles: the count, its share of the scoped set, and a meter for that
 * share. This used to be hand-rolled divs with `bg-green-600` and `text-red-600`
 * baked in, which is the one thing the console language forbids — the tone now
 * comes from the same ok/danger tokens every other screen reads.
 *
 * Headless section: the tiles carry their own labels, and inventing a panel
 * title for them would put words on screen that nobody wrote.
 */

export type StatsCardsProps = {
  manager: ExperimentsMonitorManager;
};

export const StatsCards = ({ manager }: StatsCardsProps) => {
  const { activeCount, positiveCount, negativeCount, positivePct, negativePct } = manager;

  return (
    <section className="bg-panel border-line rounded-panel border p-3.5" data-tour="performance-stats">
      <MetricGrid>
        <MetricTile label="Active Experiments" value={String(activeCount)}>
          <Meter percent={100} className="bg-bar-muted" />
        </MetricTile>

        <MetricTile
          label="Positive"
          value={String(positiveCount)}
          valueClassName="text-ok"
          trailing={<span className="num text-dim">{positivePct}%</span>}
        >
          <Meter percent={positivePct} className="bg-ok" />
        </MetricTile>

        <MetricTile
          label="Negative"
          value={String(negativeCount)}
          valueClassName="text-danger"
          trailing={<span className="num text-dim">{negativePct}%</span>}
        >
          <Meter percent={negativePct} className="bg-danger" />
        </MetricTile>
      </MetricGrid>
    </section>
  );
};
